
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/teamsreminder-hr-onboarding-performance-reviews",
      function () {
        return require("private-next-pages/article/teamsreminder-hr-onboarding-performance-reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/teamsreminder-hr-onboarding-performance-reviews"])
      });
    }
  